import { InjectionToken } from '@angular/core';
import { Feature } from 'ol';
import { Extent } from 'ol/extent';
import { Observable } from 'rxjs';
import { LayerData } from 'src/app/shared/models';

export const GeoLayerDataServiceInjector = new InjectionToken<GeoLayerDataService>(
  'to provide the GeoLayerDataService',
);

export interface GeoLayerDataService {
  /**
   * Compares a Feature's geometry with all connected
   * layer services, and returns various properties about
   * the Feature in the return type.
   *
   * Note: The layer services do not load data on-demand.
   *       If you are passing a Feature that has geometry
   *       in an area the layer service hasn't loaded yet,
   *       the LayerData checks will return their default
   *       values. The function "loadLayerFeaturesInExtent"
   *       can be used before calling this method to make
   *       sure the layer service has loaded the data.
   *
   *       This behavior was not enabled by default because
   *       most of the time you will not need this, as the
   *       layer services automatically load all data in the
   *       viewport/extent. This can be useful when you want
   *       to compare Feature geometry with layer data in an
   *       area that is not in the current viewport/extent.
   */
  getFeatureData(feature: Feature): LayerData;

  /**
   * Loads the features in the extent into all connected
   * layer services.
   */
  loadLayerFeaturesInExtent(extent: Extent): Observable<boolean[]>;
}
